import { useEffect, useState } from "react";
import { Box, Button, Divider, Flex, Text } from "@chakra-ui/react";

import PageHeader from "components/layout/PageHeader";

import StepTitle from "components/onboarding/StepTitle";
import StepDescription from "components/onboarding/StepDescription";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import PlaidConnect from "components/elements/PlaidConnect";
import { useNavigate } from "react-router-dom";

const AddBank = () => {
  const navigate = useNavigate();
  const { user } = useTenant();

  const [added, setAdded] = useState(false);

  useEffect(() => {
    setAdded(user.plaid_tokens.length > 0);
  }, [user]);

  return (
    <Box py="34px" px="26px" flex="1">
      <PageHeader title="Sync Bank Accounts" hideUser />
      <Divider mt="40px" mb="60px" />
      <StepTitle>Add Bank Accounts</StepTitle>
      <StepDescription>
        Sync your bank accounts to verify proof of funds for your loan applications.
      </StepDescription>

      <Box maxW="500px">
        <PlaidConnect />
        <Text fontSize="12px" mt="12px" textAlign="center">
          Connections are managed securely by{" "}
          <a href="https://plaid.com" target="_blank" rel="noopener noreferrer">
            Plaid
          </a>
          . 🔒
        </Text>
        <Flex justifyContent="flex-end">
          <Button
            onClick={() => {
              navigate("/setup/documents");
            }}
            size="sm"
            variant="outline"
          >
            {added ? "Continue" : "Skip"}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
export default AddBank;
